module.exports = __webpack_public_path__ + "media/gu.e456a511.wav";